module.exports = __webpack_public_path__ + "static/media/img_depoimento_register.a6e9b74f.svg";